import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadTemplateQueryVariables = SchemaTypes.Exact<{
  filter: SchemaTypes.TemplateFilteringRule;
}>;


export type DownloadTemplateQuery = (
  { __typename: 'Query' }
  & { templateFile: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'TemplateDownloadSuccessfulResponse' }
    & { result: (
      { __typename: 'Template' }
      & TemplateDataFragment
    ) }
  ) }
);

export type TemplateDataFragment = (
  { __typename: 'Template' }
  & Pick<SchemaTypes.Template, 'id' | 'key' | 'version' | 'name' | 'description' | 'createdAt' | 'updatedAt'>
  & { file: (
    { __typename: 'UploadedFile' }
    & Pick<SchemaTypes.UploadedFile, 'id' | 'url' | 'filename' | 'size'>
  ) }
);

export type ExportPerformanceResultsQueryVariables = SchemaTypes.Exact<{
  resultType: SchemaTypes.PerformanceResultType;
  filter?: SchemaTypes.InputMaybe<SchemaTypes.PerformanceResultFilterRule>;
}>;


export type ExportPerformanceResultsQuery = (
  { __typename: 'Query' }
  & { exportPerformanceResults: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'ExportPerformanceResultSuccessfulResponse' }
    & { result: (
      { __typename: 'ExportPerformanceResultResult' }
      & Pick<SchemaTypes.ExportPerformanceResultResult, 'downloadUrl'>
    ) }
  ) }
);

export type ImportPerformanceResultMutationVariables = SchemaTypes.Exact<{
  resultType: SchemaTypes.PerformanceResultType;
  file: SchemaTypes.Scalars['Upload']['input'];
  size: SchemaTypes.Scalars['Int']['input'];
}>;


export type ImportPerformanceResultMutation = (
  { __typename: 'Mutation' }
  & { importPerformanceResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'ImportPerformanceResultSuccessfulResponse' }
    & { result: (
      { __typename: 'ImportPerformanceResult' }
      & Pick<SchemaTypes.ImportPerformanceResult, 'historyId'>
    ) }
  ) }
);

export type ValidateImportPerformanceResultMutationVariables = SchemaTypes.Exact<{
  resultType: SchemaTypes.PerformanceResultType;
  file: SchemaTypes.Scalars['Upload']['input'];
}>;


export type ValidateImportPerformanceResultMutation = (
  { __typename: 'Mutation' }
  & { validateImportPerformanceResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'ValidateImportPerformanceResultSuccessfulResponse' }
    & { result: (
      { __typename: 'ValidateImportPerformanceResult' }
      & ValidateImportPerformanceResultDataFragment
    ) }
  ) }
);

export type ValidateImportPerformanceResultDataFragment = (
  { __typename: 'ValidateImportPerformanceResult' }
  & Pick<SchemaTypes.ValidateImportPerformanceResult, 'updateCount' | 'createNewCount' | 'failureCount' | 'totalRows'>
  & { errors?: SchemaTypes.Maybe<Array<(
    { __typename: 'ValidateImportPerformanceResultRowError' }
    & Pick<SchemaTypes.ValidateImportPerformanceResultRowError, 'field' | 'message' | 'rowNumber'>
  )>> }
);

export type ImportHistoryQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type ImportHistoryQuery = (
  { __typename: 'Query' }
  & { importHistory?: SchemaTypes.Maybe<(
    { __typename: 'ImportHistory' }
    & Pick<SchemaTypes.ImportHistory, 'id' | 'status'>
  )> }
);

export const TemplateDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TemplateData on Template {
  id
  key
  version
  name
  description
  file {
    id
    url
    filename
    size
  }
  createdAt
  updatedAt
}
    `;
export const ValidateImportPerformanceResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ValidateImportPerformanceResultData on ValidateImportPerformanceResult {
  updateCount
  createNewCount
  failureCount
  errors {
    field
    message
    rowNumber
  }
  totalRows
}
    `;
export const DownloadTemplateDocument = /*#__PURE__*/ gql`
    query DownloadTemplate($filter: TemplateFilteringRule!) {
  templateFile(filter: $filter) {
    ... on TemplateDownloadSuccessfulResponse {
      result {
        ...TemplateData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${TemplateDataFragmentDoc}`;

/**
 * __useDownloadTemplateQuery__
 *
 * To run a query within a React component, call `useDownloadTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTemplateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadTemplateQuery(baseOptions: Apollo.QueryHookOptions<DownloadTemplateQuery, DownloadTemplateQueryVariables> & ({ variables: DownloadTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadTemplateQuery, DownloadTemplateQueryVariables>(DownloadTemplateDocument, options);
      }
export function useDownloadTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadTemplateQuery, DownloadTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadTemplateQuery, DownloadTemplateQueryVariables>(DownloadTemplateDocument, options);
        }
// @ts-ignore
export function useDownloadTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadTemplateQuery, DownloadTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadTemplateQuery, DownloadTemplateQueryVariables>;
export function useDownloadTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadTemplateQuery, DownloadTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadTemplateQuery | undefined, DownloadTemplateQueryVariables>;
export function useDownloadTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadTemplateQuery, DownloadTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadTemplateQuery, DownloadTemplateQueryVariables>(DownloadTemplateDocument, options);
        }
export type DownloadTemplateQueryHookResult = ReturnType<typeof useDownloadTemplateQuery>;
export type DownloadTemplateLazyQueryHookResult = ReturnType<typeof useDownloadTemplateLazyQuery>;
export type DownloadTemplateSuspenseQueryHookResult = ReturnType<typeof useDownloadTemplateSuspenseQuery>;
export type DownloadTemplateQueryResult = Apollo.QueryResult<DownloadTemplateQuery, DownloadTemplateQueryVariables>;
export const ExportPerformanceResultsDocument = /*#__PURE__*/ gql`
    query ExportPerformanceResults($resultType: PerformanceResultType!, $filter: PerformanceResultFilterRule) {
  exportPerformanceResults(resultType: $resultType, filter: $filter) {
    ... on ExportPerformanceResultSuccessfulResponse {
      result {
        downloadUrl
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;

/**
 * __useExportPerformanceResultsQuery__
 *
 * To run a query within a React component, call `useExportPerformanceResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPerformanceResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPerformanceResultsQuery({
 *   variables: {
 *      resultType: // value for 'resultType'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportPerformanceResultsQuery(baseOptions: Apollo.QueryHookOptions<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables> & ({ variables: ExportPerformanceResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>(ExportPerformanceResultsDocument, options);
      }
export function useExportPerformanceResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>(ExportPerformanceResultsDocument, options);
        }
// @ts-ignore
export function useExportPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>;
export function useExportPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportPerformanceResultsQuery | undefined, ExportPerformanceResultsQueryVariables>;
export function useExportPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>(ExportPerformanceResultsDocument, options);
        }
export type ExportPerformanceResultsQueryHookResult = ReturnType<typeof useExportPerformanceResultsQuery>;
export type ExportPerformanceResultsLazyQueryHookResult = ReturnType<typeof useExportPerformanceResultsLazyQuery>;
export type ExportPerformanceResultsSuspenseQueryHookResult = ReturnType<typeof useExportPerformanceResultsSuspenseQuery>;
export type ExportPerformanceResultsQueryResult = Apollo.QueryResult<ExportPerformanceResultsQuery, ExportPerformanceResultsQueryVariables>;
export const ImportPerformanceResultDocument = /*#__PURE__*/ gql`
    mutation ImportPerformanceResult($resultType: PerformanceResultType!, $file: Upload!, $size: Int!) {
  importPerformanceResult(resultType: $resultType, file: $file, size: $size) {
    ... on ImportPerformanceResultSuccessfulResponse {
      result {
        historyId
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type ImportPerformanceResultMutationFn = Apollo.MutationFunction<ImportPerformanceResultMutation, ImportPerformanceResultMutationVariables>;

/**
 * __useImportPerformanceResultMutation__
 *
 * To run a mutation, you first call `useImportPerformanceResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPerformanceResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPerformanceResultMutation, { data, loading, error }] = useImportPerformanceResultMutation({
 *   variables: {
 *      resultType: // value for 'resultType'
 *      file: // value for 'file'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useImportPerformanceResultMutation(baseOptions?: Apollo.MutationHookOptions<ImportPerformanceResultMutation, ImportPerformanceResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPerformanceResultMutation, ImportPerformanceResultMutationVariables>(ImportPerformanceResultDocument, options);
      }
export type ImportPerformanceResultMutationHookResult = ReturnType<typeof useImportPerformanceResultMutation>;
export type ImportPerformanceResultMutationResult = Apollo.MutationResult<ImportPerformanceResultMutation>;
export type ImportPerformanceResultMutationOptions = Apollo.BaseMutationOptions<ImportPerformanceResultMutation, ImportPerformanceResultMutationVariables>;
export const ValidateImportPerformanceResultDocument = /*#__PURE__*/ gql`
    mutation ValidateImportPerformanceResult($resultType: PerformanceResultType!, $file: Upload!) {
  validateImportPerformanceResult(resultType: $resultType, file: $file) {
    ... on ValidateImportPerformanceResultSuccessfulResponse {
      result {
        ...ValidateImportPerformanceResultData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${ValidateImportPerformanceResultDataFragmentDoc}`;
export type ValidateImportPerformanceResultMutationFn = Apollo.MutationFunction<ValidateImportPerformanceResultMutation, ValidateImportPerformanceResultMutationVariables>;

/**
 * __useValidateImportPerformanceResultMutation__
 *
 * To run a mutation, you first call `useValidateImportPerformanceResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateImportPerformanceResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateImportPerformanceResultMutation, { data, loading, error }] = useValidateImportPerformanceResultMutation({
 *   variables: {
 *      resultType: // value for 'resultType'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useValidateImportPerformanceResultMutation(baseOptions?: Apollo.MutationHookOptions<ValidateImportPerformanceResultMutation, ValidateImportPerformanceResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateImportPerformanceResultMutation, ValidateImportPerformanceResultMutationVariables>(ValidateImportPerformanceResultDocument, options);
      }
export type ValidateImportPerformanceResultMutationHookResult = ReturnType<typeof useValidateImportPerformanceResultMutation>;
export type ValidateImportPerformanceResultMutationResult = Apollo.MutationResult<ValidateImportPerformanceResultMutation>;
export type ValidateImportPerformanceResultMutationOptions = Apollo.BaseMutationOptions<ValidateImportPerformanceResultMutation, ValidateImportPerformanceResultMutationVariables>;
export const ImportHistoryDocument = /*#__PURE__*/ gql`
    query ImportHistory($id: ObjectID!) {
  importHistory(id: $id) {
    ... on ImportHistory {
      id
      status
    }
  }
}
    `;

/**
 * __useImportHistoryQuery__
 *
 * To run a query within a React component, call `useImportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportHistoryQuery(baseOptions: Apollo.QueryHookOptions<ImportHistoryQuery, ImportHistoryQueryVariables> & ({ variables: ImportHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportHistoryQuery, ImportHistoryQueryVariables>(ImportHistoryDocument, options);
      }
export function useImportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportHistoryQuery, ImportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportHistoryQuery, ImportHistoryQueryVariables>(ImportHistoryDocument, options);
        }
// @ts-ignore
export function useImportHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportHistoryQuery, ImportHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ImportHistoryQuery, ImportHistoryQueryVariables>;
export function useImportHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportHistoryQuery, ImportHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ImportHistoryQuery | undefined, ImportHistoryQueryVariables>;
export function useImportHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportHistoryQuery, ImportHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportHistoryQuery, ImportHistoryQueryVariables>(ImportHistoryDocument, options);
        }
export type ImportHistoryQueryHookResult = ReturnType<typeof useImportHistoryQuery>;
export type ImportHistoryLazyQueryHookResult = ReturnType<typeof useImportHistoryLazyQuery>;
export type ImportHistorySuspenseQueryHookResult = ReturnType<typeof useImportHistorySuspenseQuery>;
export type ImportHistoryQueryResult = Apollo.QueryResult<ImportHistoryQuery, ImportHistoryQueryVariables>;